import { RouteObject, Navigate } from 'react-router-dom';
import HomePage from '../pages/home/page';
import IncentivoDashboard from '../pages/incentivo/dashboard/page';
import NotFound from '../pages/NotFound';
import CampanhasPage from '../pages/incentivo/campanhas-list/page';
import DadosBasicosPage from '../pages/incentivo/campanhas/dados-basicos/page';
import ObjetivosPage from '../pages/incentivo/campanhas/objetivos/page';
import AcoesPage from '../pages/incentivo/campanhas/acoes/page';
import RegrasPage from '../pages/incentivo/campanhas/regras/page';
import PremiacaoPage from '../pages/incentivo/campanhas/premiacao/page';
import ParticipantesPage from '../pages/incentivo/campanhas/participantes/page';
import FinanceiroPage from '../pages/incentivo/pontuacao/page';
import CompraPontosPage from '../pages/incentivo/compra-pontos/page';
import DistribuicaoPage from '../pages/incentivo/distribuicao/page';
import DepositoPage from '../pages/incentivo/deposito/page';
import ExtratoContaDigitalPage from '../pages/incentivo/extrato-conta-digital/page';
import ExtratoPontosPage from '../pages/incentivo/extrato-pontos/page';
import ParticipantesListaPage from '../pages/incentivo/participantes/lista/page';
import EfetuarCadastrosPage from '../pages/incentivo/participantes/cadastros/page';
import EnviarConvitesPage from '../pages/incentivo/participantes/enviar-convites/page';
import SimuladorPage from '../pages/incentivo/simulador/page';
import RecompensasPage from '../pages/incentivo/recompensas/page';
import ParticipantesPerformancePage from '../pages/incentivo/participantes/performance/page';
import SimuladorIAPage from '../pages/incentivo/simulador-ia/page';
import ConciliacaoContabilPage from '../pages/incentivo/conciliacao-contabil/page';

// Gamificação Pages
import GamificacaoDashboardPage from '../pages/gamificacao/dashboard/page';
import MissoesPage from '../pages/gamificacao/missoes/page';
import RegrasXPPage from '../pages/gamificacao/regras-xp/page';
import NiveisPage from '../pages/gamificacao/niveis/page';
import DistintivosPage from '../pages/gamificacao/distintivos/page';
import JogosPage from '../pages/gamificacao/jogos/page';
import LogsPage from '../pages/gamificacao/logs/page';
import AnalyticsPage from '../pages/gamificacao/analytics/page';

// Auditoria Pages
import AuditoriaDashboardPage from '../pages/auditoria/dashboard/page';
import VendasAuditoriaPage from '../pages/auditoria/vendas/page';
import DetalheVendaPage from '../pages/auditoria/vendas/[id]/page';
import RegrasAuditoriaPage from '../pages/auditoria/regras/page';
import TrilhaAuditoriaPage from '../pages/auditoria/trilha/page';
import RelatoriosAuditoriaPage from '../pages/auditoria/relatorios/page';

// Landing Page
import LandingPage from '../pages/landing/page';
import SolicitarDemoPage from '../pages/solicitar-demo/page';
import SaudePage from '../pages/saude/page';
import PlataformaPage from '../pages/plataforma/page';

// Auth Guard
import PrivateRoute from '../components/auth/PrivateRoute';

// Admin Auth Guard
import AdminPrivateRoute from '../components/auth/AdminPrivateRoute';

// Admin Login
import AdminLoginPage from '../pages/admin/login/page';

// Admin Gestão de Acesso
import GestaoAcessoPage from '../pages/admin/gestao-acesso/page';

// Perfil / Empresa / Configurações
import PerfilPage from '../pages/perfil/page';
import EmpresaPage from '../pages/empresa/page';
import ConfiguracoesPage from '../pages/configuracoes/page';

// Backoffice Auth Guard
import BackofficePrivateRoute from '../components/auth/BackofficePrivateRoute';

// Premiado Pages
import { ParticipanteLayout } from '../components/premiado/layout/ParticipanteLayout';
import ParticipanteHome from '../pages/premiado/home/page';
import ParticipantePerfil from '../pages/premiado/perfil/page';
import ParticipanteCampanhas from '../pages/premiado/campanhas/page';
import ParticipanteCampanhaDetalhes from '../pages/premiado/campanhas/detalhes/page';
import ParticipanteMissoes from '../pages/premiado/missoes/page';
import ParticipanteNiveis from '../pages/premiado/niveis/page';
import ParticipanteDistintivos from '../pages/premiado/distintivos/page';
import ParticipanteJogos from '../pages/premiado/jogos/page';
import ParticipanteTreinamento from '../pages/premiado/treinamento/page';
import ParticipanteRecompensas from '../pages/premiado/recompensas/page';
import ParticipanteSuporte from '../pages/premiado/suporte/page';
import ParticipanteExtrato from '../pages/premiado/extrato/page';
import ParticipanteConfiguracoes from '../pages/premiado/configuracoes/page';
import PremiadoLoginPage from '../pages/premiado/login/page';
import ParticipanteCadastro from '../pages/premiado/cadastro/page';
import PremiadoRecuperarSenhaPage from '../pages/premiado/recuperar-senha/page';
import SplashScreen from '../pages/premiado/splash/page';
import EmailsPreviewPage from '../pages/premiado/emails-preview/page';
import ParticipanteSocial from '../pages/premiado/social/page';
import ParticipanteFeed from '../pages/premiado/feed/page';
import ParticipanteAmigos from '../pages/premiado/amigos/page';
import ParticipanteComparacao from '../pages/premiado/comparacao/page';

// Backoffice Pages
import BackofficeFinanceiroDashboardPage from '../pages/backoffice/financeiro/dashboard/page';
import BackofficeLoginPage from '../pages/backoffice/login/page';
import BackofficeDashboardPage from '../pages/backoffice/dashboard/page';
import BackofficeAtendimentoPage from '../pages/backoffice/atendimento/page';
import BackofficeAtendimentoDetalhePage from '../pages/backoffice/atendimento/[id]/page';
import BackofficeFinanceiroPage from '../pages/backoffice/financeiro/page';
import BackofficeOperacoesManuaisPage from '../pages/backoffice/financeiro/operacoes/page';
import BackofficeEmpresasPage from '../pages/backoffice/empresas/page';
import BackofficeEmpresaDetalhePage from '../pages/backoffice/empresas/[id]/page';
import BackofficeComunicadosPage from '../pages/backoffice/comunicados/page';
import BackofficeConfiguracoesPage from '../pages/backoffice/configuracoes/page';
import BackofficeAuditoriaPage from '../pages/backoffice/auditoria/page';
import BackofficeAuditoriaConfiguracoesPage from '../pages/backoffice/auditoria-configuracoes/page';
import SelecionarEmpresaConfigPage from '../pages/backoffice/empresas/configuracoes/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/solicitar-demo',
    element: <SolicitarDemoPage />,
  },
  {
    path: '/saude',
    element: <SaudePage />,
  },
  {
    path: '/plataforma',
    element: <PlataformaPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/gestao-acesso',
    element: <AdminPrivateRoute><GestaoAcessoPage /></AdminPrivateRoute>,
  },
  {
    path: '/admin/niveis-acesso',
    element: <AdminPrivateRoute><GestaoAcessoPage /></AdminPrivateRoute>,
  },
  {
    path: '/perfil',
    element: <AdminPrivateRoute><PerfilPage /></AdminPrivateRoute>,
  },
  {
    path: '/empresa',
    element: <AdminPrivateRoute><EmpresaPage /></AdminPrivateRoute>,
  },
  {
    path: '/configuracoes',
    element: <AdminPrivateRoute><ConfiguracoesPage /></AdminPrivateRoute>,
  },
  {
    path: '/admin',
    element: <AdminPrivateRoute><HomePage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/dashboard',
    element: <AdminPrivateRoute><IncentivoDashboard /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas',
    element: <AdminPrivateRoute><CampanhasPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/dados-basicos',
    element: <AdminPrivateRoute><DadosBasicosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/objetivos',
    element: <AdminPrivateRoute><ObjetivosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/acoes',
    element: <AdminPrivateRoute><AcoesPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/regras',
    element: <AdminPrivateRoute><RegrasPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/premiacao',
    element: <AdminPrivateRoute><PremiacaoPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/campanhas/participantes',
    element: <AdminPrivateRoute><ParticipantesPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/simulador',
    element: <AdminPrivateRoute><SimuladorPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/simulador-ia',
    element: <AdminPrivateRoute><SimuladorIAPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/pontuacao',
    element: <AdminPrivateRoute><FinanceiroPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/compra-pontos',
    element: <AdminPrivateRoute><CompraPontosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/distribuicao',
    element: <AdminPrivateRoute><DistribuicaoPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/deposito',
    element: <AdminPrivateRoute><DepositoPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/extrato-conta-digital',
    element: <AdminPrivateRoute><ExtratoContaDigitalPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/extrato-pontos',
    element: <AdminPrivateRoute><ExtratoPontosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/conciliacao-contabil',
    element: <AdminPrivateRoute><ConciliacaoContabilPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/participantes',
    element: <AdminPrivateRoute><ParticipantesListaPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/participantes/cadastros',
    element: <AdminPrivateRoute><EfetuarCadastrosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/participantes/enviar-convites',
    element: <AdminPrivateRoute><EnviarConvitesPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/participantes/performance',
    element: <AdminPrivateRoute><ParticipantesPerformancePage /></AdminPrivateRoute>
  },
  {
    path: '/admin/incentivo/recompensas',
    element: <AdminPrivateRoute><RecompensasPage /></AdminPrivateRoute>
  },
  // Auditoria Routes
  {
    path: '/admin/auditoria/dashboard',
    element: <AdminPrivateRoute><AuditoriaDashboardPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/auditoria/vendas',
    element: <AdminPrivateRoute><VendasAuditoriaPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/auditoria/vendas/:id',
    element: <AdminPrivateRoute><DetalheVendaPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/auditoria/regras',
    element: <AdminPrivateRoute><RegrasAuditoriaPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/auditoria/trilha',
    element: <AdminPrivateRoute><TrilhaAuditoriaPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/auditoria/relatorios',
    element: <AdminPrivateRoute><RelatoriosAuditoriaPage /></AdminPrivateRoute>
  },
  // Gamificação Routes
  {
    path: '/admin/gamificacao/dashboard',
    element: <AdminPrivateRoute><GamificacaoDashboardPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/missoes',
    element: <AdminPrivateRoute><MissoesPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/regras-xp',
    element: <AdminPrivateRoute><RegrasXPPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/niveis',
    element: <AdminPrivateRoute><NiveisPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/distintivos',
    element: <AdminPrivateRoute><DistintivosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/jogos',
    element: <AdminPrivateRoute><JogosPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/logs',
    element: <AdminPrivateRoute><LogsPage /></AdminPrivateRoute>
  },
  {
    path: '/admin/gamificacao/analytics',
    element: <AdminPrivateRoute><AnalyticsPage /></AdminPrivateRoute>
  },
  // Backoffice Routes
  {
    path: '/backoffice/login',
    element: <BackofficeLoginPage />,
  },
  {
    path: '/backoffice/dashboard',
    element: <BackofficePrivateRoute><BackofficeDashboardPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/atendimento',
    element: <BackofficePrivateRoute><BackofficeAtendimentoPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/atendimento/:id',
    element: <BackofficePrivateRoute><BackofficeAtendimentoDetalhePage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/financeiro',
    element: <BackofficePrivateRoute allowedRoles={['admin', 'financeiro']}><BackofficeFinanceiroPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/financeiro/dashboard',
    element: <BackofficePrivateRoute allowedRoles={['admin', 'financeiro']}><BackofficeFinanceiroDashboardPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/financeiro/operacoes',
    element: <BackofficePrivateRoute allowedRoles={['admin', 'financeiro']}><BackofficeOperacoesManuaisPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/empresas/configuracoes',
    element: <BackofficePrivateRoute><SelecionarEmpresaConfigPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/empresas/:id',
    element: <BackofficePrivateRoute><BackofficeEmpresaDetalhePage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/comunicados',
    element: <BackofficePrivateRoute><BackofficeComunicadosPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/configuracoes',
    element: <BackofficePrivateRoute allowedRoles={['admin']}><BackofficeConfiguracoesPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/auditoria/configuracoes',
    element: <BackofficePrivateRoute allowedRoles={['admin']}><BackofficeAuditoriaConfiguracoesPage /></BackofficePrivateRoute>
  },
  {
    path: '/backoffice/auditoria',
    element: <BackofficePrivateRoute><BackofficeAuditoriaPage /></BackofficePrivateRoute>
  },
  // Premiado Public Routes
  {
    path: '/premiado/login',
    element: <PremiadoLoginPage />
  },
  {
    path: '/premiado/cadastro',
    element: <ParticipanteCadastro />,
  },
  {
    path: '/premiado/register',
    element: <Navigate to="/premiado/cadastro" replace />
  },
  {
    path: '/premiado/recuperar-senha',
    element: <PremiadoRecuperarSenhaPage />,
  },
  {
    path: '/premiado/splash',
    element: <SplashScreen />
  },
  {
    path: '/premiado/emails-preview',
    element: <EmailsPreviewPage />
  },
  // Premiado Protected Routes
  {
    path: '/premiado',
    element: <PrivateRoute><ParticipanteLayout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/premiado/home" replace />
      },
      {
        path: 'home',
        element: <ParticipanteHome />
      },
      {
        path: 'perfil',
        element: <ParticipantePerfil />
      },
      {
        path: 'campanhas',
        element: <ParticipanteCampanhas />
      },
      {
        path: 'campanhas/:id',
        element: <ParticipanteCampanhaDetalhes />
      },
      {
        path: 'missoes',
        element: <ParticipanteMissoes />
      },
      {
        path: 'niveis',
        element: <ParticipanteNiveis />
      },
      {
        path: 'distintivos',
        element: <ParticipanteDistintivos />
      },
      {
        path: 'jogos',
        element: <ParticipanteJogos />
      },
      {
        path: 'treinamento',
        element: <ParticipanteTreinamento />
      },
      {
        path: 'social',
        element: <ParticipanteSocial />
      },
      {
        path: 'feed',
        element: <ParticipanteFeed />
      },
      {
        path: 'amigos',
        element: <ParticipanteAmigos />
      },
      {
        path: 'comparacao',
        element: <ParticipanteComparacao />
      },
      {
        path: 'recompensas',
        element: <ParticipanteRecompensas />
      },
      {
        path: 'extrato',
        element: <ParticipanteExtrato />
      },
      {
        path: 'comprovantes',
        element: <Navigate to="/premiado/recompensas?aba=resgates" replace />
      },
      {
        path: 'suporte',
        element: <ParticipanteSuporte />
      },
      {
        path: 'configuracoes',
        element: <ParticipanteConfiguracoes />
      }
    ]
  },
  // Catch-all deve ser sempre a última rota
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;